export default __webpack_public_path__ + "static/media/JO copy.a5122068.png";